import React from 'react'
import { Popover, OverlayTrigger } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import styles from './styles.less'
import { T } from 'components/components/i18n'

const Unit = (props) => {
  const {
    tooltip,
    unit,
  } = props
  return  (
    <React.Fragment>
      <T id={unit} />
      {tooltip && (
        <OverlayTrigger
          overlay={
            <Popover>
              <T id={tooltip} />
            </Popover>
          }
        >
          <button className={`button-link ${styles.icon}`}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </button>
        </OverlayTrigger>
      )}
    </React.Fragment>
  )
}

export default Unit